export default "__VITE_PUBLIC_ASSET__9af62c31__"